import { createAsyncThunk } from "@reduxjs/toolkit";
import { admin_apiEndpoint, config_variable } from "../../helper/commonApi";
import { GetApiCall, ApiCall } from "../../helper/axios";

export const getPriceUpdateAsync = createAsyncThunk('fetch/getPriceUpdate', async (_, thunkAPI) => {
    const state = thunkAPI.getState();
    const store_data = state?.commonData?.store_data;
    const res = await GetApiCall('GET', `/price-updates?shop=${config_variable.shop_name}`, { authentication: store_data?.token })
    if (res.data.success && res.status === 200) {
        return res?.data?.data;
    } else {
        if (window.location.hostname !== 'localhost') {
            window.parent.location.href = `${admin_apiEndpoint}?shop=${config_variable.shop_name}&host=${config_variable?.config.host}`;
        }
    }
});

export const getGoldPurityPriceAsync = createAsyncThunk('fetch/getGoldPurityPrice', async (_, thunkAPI) => {
    const state = thunkAPI.getState();
    const store_data = state?.commonData?.store_data;
    const res = await GetApiCall('GET', `/gold-purity-price?shop=${config_variable.shop_name}`, { authentication: store_data?.token })
    if (res.data.success && res.status === 200) {
        return res?.data?.data;
    } else {
        if (window.location.hostname !== 'localhost') {
            window.parent.location.href = `${admin_apiEndpoint}?shop=${config_variable.shop_name}&host=${config_variable?.config.host}`;
        }
    }
});

export const createPriceUpdateAsync = createAsyncThunk('fetch/createPriceUpdate', async (param, thunkAPI) => {
    const state = thunkAPI.getState();
    const store_data = state?.commonData?.store_data;
    const res = await ApiCall('POST', `/price-updates?shop=${config_variable.shop_name}`, param.payload, { authentication: store_data?.token })
    await new Promise((res) =>
        setTimeout(() => {
            res();
        }, [1000])
    );
    if (res.data.success && res.status === 201) {
        param.callback(res.data.success, res.data.message);
        return res?.data?.data;
    } else {
        if (window.location.hostname !== 'localhost') {
            window.parent.location.href = `${admin_apiEndpoint}?shop=${config_variable.shop_name}&host=${config_variable?.config.host}`;
        }
    }
});

export const createMetafieldDefinitionAsync = createAsyncThunk('fetch/createMetafieldDefinition', async (param, thunkAPI) => {
    const state = thunkAPI.getState();
    const store_data = state?.commonData?.store_data;
    const res = await ApiCall('POST', `/metafield?shop=${config_variable.shop_name}`, param.payload, { authentication: store_data?.token })
    if (res.data.success && res.status === 201) {
        param.callback(res.data.success, res.data.message);
        return res?.data;
    } else {
        if (window.location.hostname !== 'localhost') {
            window.parent.location.href = `${admin_apiEndpoint}?shop=${config_variable.shop_name}&host=${config_variable?.config.host}`;
        }
    }
});